export default __webpack_public_path__ + "static/media/toggle-on.9be92876.svg";